/* Built In Imports */
import dynamic from 'next/dynamic';

import React from 'react';
/* External Imports */
import { Box } from '@chakra-ui/react';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
// import RenderSections from '@moms/Common/RenderSections';
// import SectionCommonUI from '@moms/Common/SectionCommonUi';
/* Styles */
/* Services */
const RenderSections = dynamic(() => import('@moms/Common/RenderSections'), {
  loading: () => <p>Loading...</p>,
});
const SectionCommonUi = dynamic(() => import('@moms/Common/SectionCommonUi'), {
  loading: () => <p>Loading...</p>,
});
/**
 *
 * @param {Object} pageData
 * @param {String} region
 * @param {String} lang
 * @returns
 */
const MomUi = ({ pageData, region, lang, firstLevel }) => {
  // console.log(pageData, 'pageData');
  if (pageData) {
    return (
      <Box bgColor={'#010102'}>
        {pageData?.body?.length && pageData?.body?.length
          ? pageData?.body?.map((section, i) => {
              return (
                <RenderSections
                  pageData={pageData}
                  section={section}
                  region={region}
                  lang={lang}
                  key={nanoid(4)}
                  firstLevel={firstLevel}
                />
              );
            })
          : null}
        {pageData?.blogPostGroup?.length && pageData?.blogPostGroup?.length
          ? pageData?.blogPostGroup?.map((section, i) => {
              return (
                <SectionCommonUi
                  pageData={pageData}
                  sectionContent={section}
                  region={region}
                  lang={lang}
                  key={nanoid(4)}
                />
              );
            })
          : null}
      </Box>
    );
  }
};

export default MomUi;
